export default __webpack_public_path__ + "static/media/006-Colosseum.d1bfe9df.svg";